import {
  BrowserRouter, Navigate, Routes, Route,
} from 'react-router-dom';

import MainLayout from '../layouts/MainLayout';
import ConsoleLayout from '../layouts/ConsoleLayout';
import AdminLayout from '../layouts/AdminLayout';
// import Home from '../pages/Home';
import Login from '../pages/Login';
import AdminLogin from '../pages/AdminLogin';
import Logout from '../pages/Logout';
import Signup from '../pages/Signup';
import ForgotPassword from '../pages/ForgotPassword';
import PasswordReset from '../pages/PasswordReset';
import NotFound from '../pages/NotFound';
import Profile from '../pages/Profile';
import Payment from '../pages/Payment';
// import Dashboard from '../pages/Dashboard';
import Users from '../pages/Users';
import Settings from '../pages/Settings';
import AuthProvider from '../hooks/AuthProvider';
import Projects from '../pages/Projects';
import Resources from '../pages/Resources';
import DocFile from '../pages/DocFile';
import Chatbot from '../pages/Chatbot';
import Services from '../pages/Services';
import Guide from '../pages/Guide';
import ContactUs from '../pages/ContactUs';
import AdminDashboard from '../pages/Admin/AdminDashboard';
import AdminUsers from '../pages/Admin/AdminUsers';
import AdminOrgnization from '../pages/Admin/AdminOrgnization';
import AdminDepartments from '../pages/Admin/AdminDepartment';
import AdminProjects from '../pages/Admin/AdminProject';
import AdminResources from '../pages/Admin/AdminResource';
import AlertHandler from '../components/AlertHandler';
import AdminQuestionSets from '../pages/Admin/AdminQuestionSets';
import AdminQuestions from '../pages/Admin/AdminQuestions';
import QuestionSets from '../pages/QuestionSets';
import Questions from '../pages/Questions';


const baseUrl = '/EvaClient';
//const baseUrl = '/Client';

function App() {
  return (
    <BrowserRouter basename={baseUrl}>
      <AlertHandler />
      <AuthProvider>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route path="" element={<Login />} />
            <Route path="login" element={<Login />} />
            <Route path="adminlogin" element={<AdminLogin />} />
            <Route path="logout" element={<Logout />} />
            <Route path="signup" element={<Signup />} />
            <Route path="forgot" element={<ForgotPassword />} />
            <Route path="resetpassword" element={<PasswordReset />} />
            <Route path="resetpassword/:token" element={<PasswordReset />} />
            <Route path="not-found" element={<NotFound />} />
            <Route path="contact" element={<ContactUs />} />
            <Route path="*" element={<Navigate to="/not-found" />} />
          </Route>
          <Route path="console" element={<ConsoleLayout />}>
            <Route path="" element={<Projects />} />
            <Route path="profile" element={<Profile />} />
            <Route path="payment" element={<Payment />} />
            <Route path="users" element={<Users />} />
            <Route path="projects" element={<Projects />} />
            <Route path="resources" element={<Resources />} />
            <Route path="docfile" element={<DocFile />} />
            <Route path="docfile/:id" element={<DocFile />} />
            <Route path="chatbot" element={<Chatbot />} />
            <Route path="chatbot/:id" element={<Chatbot />} />
            <Route path="services" element={<Services />} />
            <Route path="guide" element={<Guide />} />
            <Route path="questionsets" element={<QuestionSets />} />
            <Route path="questionsets/:id" element={<Questions/>} />
           </Route>
          <Route path="admin" element={<AdminLayout />}>
            <Route path="" element={<AdminDashboard />} /> 
            <Route path="departments" element={<AdminDepartments />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="resources" element={<AdminResources />} />
            <Route path="profile" element={<Profile />} />
            <Route path="users" element={<AdminDashboard />} />
            <Route path="users_ru" element={<AdminUsers />} />
            <Route path="settings" element={<Settings />} />
            <Route path="chatbot" element={<Chatbot />} />
            <Route path="chatbot/:id" element={<Chatbot />} />
            <Route path="questionsets" element={<AdminQuestionSets/>} />
            <Route path="questionsets/:id" element={<AdminQuestions/>} />
            <Route path="orgnization" element={<AdminOrgnization />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;